package com.exura.chartsJS

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.exura.util.jso
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Canvas
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.exura.ChartsRawPastelPalette.toCssRgba
import com.exura.surface
import com.exura.ui.Dimens
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.minHeight
import org.w3c.dom.HTMLCanvasElement


@Composable
fun ComposeChart(
    content: ChartScope.() -> Unit
) {
    val colorMode = ColorMode.current
    val palette = colorMode.toPalette()

    DisposableEffect(palette) {
        Chart.defaults.color = palette.color.toCssRgba()
        Chart.defaults.scale.ticks.color = palette.color.toCssRgba()
        Chart.defaults.scale.grid.color = palette.border.toCssRgba()
        Chart.defaults.scale.grid.borderColor = palette.border.toCssRgba()
        onDispose {  }
    }

    val scope = ChartScope().apply {
        plotBackgroundColor(palette.surface.toCssRgba())
        content()
    }
    if (scope.plotBackgroundColor != null) {
        if (scope.options.plugins == undefined) scope.options.plugins = jso {}

        // We define a specific namespace for our plugin
        scope.options.plugins.customCanvasBackgroundColor = jso {
            this.color = scope.plotBackgroundColor
        }
    }


    var chartInstance by remember { mutableStateOf<Chart?>(null) }
    var canvasElement by remember { mutableStateOf<HTMLCanvasElement?>(null) }

    DisposableEffect(scope, canvasElement) {
        val element = canvasElement

        if (element != null) {

            if (scope.options.scales == undefined) scope.options.scales = jso {}
            if (scope.options.scales.x == undefined) scope.options.scales.x = jso {}

            val currentXType = scope.options.scales.x.type
            if (currentXType == undefined && scope.inferredXAxisType != null) {
                scope.options.scales.x.type = scope.inferredXAxisType
            }

            val dataObj = jso {
                if (scope.labels != null) this.labels = scope.labels
                this.datasets = scope.datasets.toTypedArray()
            }

            if (chartInstance == null) {
                val config = jso {
                    this.type = scope.type ?: "bar"
                    this.data = dataObj
                    this.options = scope.options
                    this.plugins = arrayOf(
                        jso {
                            id = "customCanvasBackgroundColor"
                            beforeDraw = { chart: dynamic, args: dynamic, options: dynamic ->
                                // 3. READ FROM OPTIONS (The dynamic 3rd arg)
                                // This 'options' maps directly to scope.options.plugins.customCanvasBackgroundColor
                                val color = options?.color

                                if (color != null) {
                                    val ctx = chart.ctx
                                    val area = chart.chartArea
                                    if (area != undefined) {
                                        ctx.save()
                                        ctx.fillStyle = color // Use the value from options

                                        val left = area.left as Double
                                        val top = area.top as Double
                                        val width = (area.right as Double) - left
                                        val height = (area.bottom as Double) - top

                                        ctx.fillRect(left, top, width, height)
                                        ctx.restore()
                                    }
                                }
                            }
                        }
                    )
                }
                chartInstance = Chart(element, config)
            } else {
                chartInstance!!.data = dataObj
                chartInstance!!.options = scope.options
                chartInstance!!.update()
            }
        }

        onDispose {
        }
    }

    Canvas(attrs = {
        style {
            width(Dimens.chartParentWith)
            height(Dimens.chartParentHeight)
            minHeight(Dimens.chartMinHeight)
        }
        ref { element ->
            canvasElement = element

            onDispose {
                chartInstance?.destroy()
                chartInstance = null
                canvasElement = null
            }
        }
    })
}
